import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { Menu } from '../../navigation-menu.component';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-navigation-menu-item',
  standalone: false,
  templateUrl: './navigation-menu-item.component.html',
  styleUrls: ['./navigation-menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationMenuItemComponent {
  @Input() item!: Menu;
}
